
import { PropTypes } from 'prop-types';
import YouTubeEmbed from '../../utils/youtubeEmbed';
const TakeATour = ({ description, videoPath }) => {
    return (
        <div className="flex flex-col items-center justify-center gap-4 pt-8 sm:pt-0">
            <h1 className="text-center text-slate-900 text-5xl font-bold ">Take a Tour</h1>
            <p className="max-w-3xl text-center text-sky-950 text-opacity-70 text-base font-normal  leading-normal">{description}</p>
            <div className="w-full max-w-5xl h-[30rem] 2xl:max-w-7xl 2xl:h-[40rem] overflow-hidden rounded-2xl  bg-gray-200">
               <YouTubeEmbed videoUrl={videoPath} />
                {/* <iframe className="max-w-full w-full h-full " src={videoPath} title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe> */}
            </div>
        </div>
    )
}
TakeATour.propTypes = {
    description: PropTypes.string,
    videoPath: PropTypes.string,
}
export default TakeATour